import script from "./studySTPage.vue?vue&type=script&setup=true&lang=js"
export * from "./studySTPage.vue?vue&type=script&setup=true&lang=js"

import "./studySTPage.vue?vue&type=style&index=0&id=a1c8a246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1c8a246"]])

export default __exports__